@if (toonNoodzakelijk() || toonGewenst()) {
    <div class="bouwsuggesties node-dom-icon-container">
        @if (toonNoodzakelijk()) {
            <div class="bouwsuggestie noodzakelijk animatie node-dom-icon"
                 [attr.data-status]="regelstatusNoodzakelijk()"
                 (click)="klikLampje()"
                 (pointerenter)="mouseInLampje('noodzakelijk')"
                 (pointerleave)="mouseOutLampje()">
                <i class="dl-fa4 dl-fa4--lampje" [class.animeer]="animeerNoodzakelijk()" (animationend)="animeerNoodzakelijk.set(false)"></i>
                <span class="numregels">{{ aantallen().numNoodzakelijk }}</span>
            </div>
        }
        @if (toonGewenst()) {
            <div class="bouwsuggestie gewenst animatie node-dom-icon"
                 [class.nietklikbaar]="toonNoodzakelijk()"
                 [attr.data-status]="regelstatusGewenst()"
                 (click)="!toonNoodzakelijk() && klikLampje()"
                 (pointerenter)="mouseInLampje('gewenst')"
                 (pointerleave)="mouseOutLampje()">
                <i class="dl-fa4 dl-fa4--lampje" [class.animeer]="animeerGewenst()" (animationend)="animeerGewenst.set(false)"></i>
                <span class="numregels">{{ aantallen().numGewenst }}</span>
            </div>
        }
    </div>
}
@if (dlgOpen()) {
    <dl-node-dom-ballon [anker]="getBouwsuggestieAnker()" (hoverIn)="bijBallonIn()" (hoverOut)="bijBallonUit()">
        <div class="bouwsuggestie_uitleg" [innerHTML]="huidigeRegeluitleg()"></div>
        @if (huidigeRegelinfo() && huidigeRegelinfo()!.regel.soort !== 'hard') {
            <div class="bouwsuggestie_btns" [class.fullReadonly]="fullReadonly()">
                <div (click)="sluitDlgBtn()">{{ 'BOUWSUGGESTIE.SLUIT' | translate }}</div>
                @if (huidigeRegelinfo()!.regel.ack && !huidigeRegelinfo()!.regel.bevestig_gezien) {
                    <div (click)="beantwoordRegel(2)">{{ 'BOUWSUGGESTIE.ACK' | translate }}</div>
                }
                @if (huidigeRegelinfo()!.regel.ack) {
                    <div (click)="beantwoordRegel(3)">
                        {{ (huidigeRegelinfo()!.regel.bevestig_gezien ? 'BOUWSUGGESTIE.GEZIEN' : 'BOUWSUGGESTIE.NEGEER') | translate }}
                    </div>
                }
            </div>
        }
    </dl-node-dom-ballon>
}
